import { useState, useEffect } from 'react';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';

const COOKIE_CONSENT_KEY = 'karmaio_cookie_consent';

export function CookieBanner() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(COOKIE_CONSENT_KEY);
    if (!consent) {
      // Small delay for smoother appearance
      const timer = setTimeout(() => setIsVisible(true), 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, 'accepted');
    setIsVisible(false);
  };

  const handleReject = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, 'rejected');
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4 animate-[fade-in_0.5s_ease-out]">
      <div className="container mx-auto max-w-4xl">
        <div className="bg-card border border-border rounded-xl p-6 shadow-xl backdrop-blur-sm">
          <div className="flex flex-col md:flex-row items-start md:items-center gap-4">
            {/* Text */}
            <div className="flex-1 space-y-2">
              <h3 className="font-semibold text-foreground">🍪 Questo sito utilizza i cookie</h3>
              <p className="text-sm text-muted-foreground">
                Utilizziamo i cookie per migliorare la tua esperienza sul nostro sito. 
                Continuando a navigare, accetti l'uso dei cookie in conformità con la nostra{' '}
                <Link to="/privacy-policy" className="text-primary underline underline-offset-2 font-semibold hover:text-primary/80">
                  Privacy Policy
                </Link>.
              </p>
            </div>

            {/* Buttons */}
            <div className="flex gap-3 shrink-0">
              <Button
                variant="outline"
                onClick={handleReject}
                className="border-muted-foreground/30 hover:bg-muted"
              >
                Rifiuta
              </Button>
              <Button
                onClick={handleAccept}
                className="bg-primary text-background font-semibold hover:bg-primary/90"
              >
                Accetta
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
